module.exports = __webpack_public_path__ + "static/media/valora.1aa85ced.jpeg";